import { useEffect } from 'react';
import keycloak from '../Keycloak';

const useKeycloak = () => {
    useEffect(() => {
        if(!keycloak.authenticated){
            keycloak.login();
        }
    }, [keycloak]);
    return {
        ...keycloak
    }
}

export default useKeycloak;